import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { ArchiveTaskDialog } from "@/routes/_layout/templates/-components/archive-task-dialog"

export const Route = createFileRoute(
  "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId/archive",
)({
  component: ArchiveTemplateQuoteTask,
})

function ArchiveTemplateQuoteTask(): React.ReactElement {
  const { packageId, taskId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <ArchiveTaskDialog
      taskId={taskId}
      onArchived={() =>
        navigate({
          to: "/templates/quotes/$packageId",
          params: { packageId },
          search: true,
        })
      }
      onCancel={() =>
        navigate({
          to: "/templates/quotes/$packageId/tasks/$taskId",
          params: { packageId, taskId },
          search: true,
        })
      }
    />
  )
}
